import React from 'react';
import './styles/App.scss';
import { Providers } from './Providers';
import { App } from './App';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/solid.css';

import { createRoot } from 'react-dom/client';

const domNode = document.getElementById('root');
const root = createRoot(domNode);

root.render(
  <Providers>
    <App />
  </Providers>
);
